import { Injectable } from '@angular/core';
import { ObjectId } from 'bson';

@Injectable({ providedIn: 'root' })
export class UuidService {
    newMongoId(): string {
        const objId = new ObjectId();
        return objId.toHexString();
    }
}
